/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import CommonTable from '../../../../../components/CommonTable';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import styles from '../styles.module.css';
import container from '../../../../../../public/images/container.png';
import charges from '../../../../../../public/images/charges.png';
import consumption from '../../../../../../public/images/consumption.png';
import period from '../../../../../../public/images/period.png';
import {
  formatCurrency,
  NumberFormat,
} from '../../../../../services/utils/commonUtils';

const ConsumptionCard = ({ consumptionData, t }) => {
  const [expandedPeriods, setExpandedPeriods] = useState({});
  const togglePeriod = (index) => {
    setExpandedPeriods((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  useEffect(() => {
    if (consumptionData.length > 0) {
      setExpandedPeriods({ 0: true });
    }
  }, [consumptionData]);

  const consumptionsWithSlabs = [
    {
      title: t('label_slab'),
      dataIndex: 'slab',
      key: 'slab',
    },
    {
      title: t('label_Usage'),
      dataIndex: 'units',
      key: 'units',
      align: 'right',
      render: (value) => `${NumberFormat(value)} ${t('label_kWh')}`,
    },
    {
      title: t('label_Unit_Price'),
      dataIndex: 'rate',
      key: 'rate',
      align: 'right',

      render: (value) => formatCurrency(value),
    },
    {
      title: t('label_Total_price'),
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',

      render: (value) => formatCurrency(value),
    },
  ];

  return (
    <div className={styles.consumptionCardContainer}>
      <div className={styles.cardHeaderNew}>
        <div className={styles.cardHeaderLabel}>{t('label_consumption')}</div>
        <div>
          <img src={container} alt="container icon" />
        </div>
      </div>
      {consumptionData.map((item, index) => (
        <div key={index} className={styles.newWrapper}>
          <div className={styles.consumptionCardWrapper}>
            <Row gutter={[16, 12]} justify="space-around" align="top">
              {/* Period Column */}
              <Col className={styles.colitems} xs={24} sm={24} md={6} lg={6}>
                <div className={styles.consumptionCard}>
                  <div className={styles.cardHeader}>
                    <img src={period} alt="period icon" />
                  </div>
                  <div className={styles.cardHeaderTxt}>
                    <span className={styles.consumptionCardLabel}>
                      {t('label_PERIOD')}
                    </span>
                    <p className={styles.consumptionData}>
                      {item.from} {t('label_to')} {item.to}
                    </p>
                  </div>
                </div>
              </Col>
              {/* Fixed Charges Column */}
              <Col className={styles.colitems} xs={24} sm={24} md={7} lg={7}>
                <div className={styles.consumptionCard}>
                  <div className={styles.cardHeader}>
                    <img src={charges} alt="charges icon" />
                  </div>
                  <div className={styles.cardHeaderTxt}>
                    <span className={styles.consumptionCardLabel}>
                      {t('label_fixed_charges/period')}
                    </span>

                    <p className={styles.consumptionData}>
                      {formatCurrency(item.fixedCharge)}
                    </p>
                  </div>
                </div>
              </Col>
              {/* Consumption Units Column */}
              <Col className={styles.colitems} xs={24} sm={24} md={6} lg={7}>
                <div className={styles.consumptionCard}>
                  <div className={styles.cardHeader}>
                    <img src={consumption} alt="consumption icon" />
                  </div>
                  <div className={styles.cardHeaderTxt}>
                    <span className={styles.consumptionCardLabel}>
                      {t('label_consumption_chages/period')}
                    </span>
                    <p className={styles.consumptionData}>
                      {formatCurrency(item.amount)}
                    </p>
                  </div>
                </div>
              </Col>
              {/* Expand/Collapse Arrow */}
              {item.slabs && item.slabs.length > 0 && (
                <Col
                  className={styles.colitemsarrow}
                  xs={24}
                  sm={24}
                  md={6}
                  lg={3}
                >
                  <div className={styles.arrowCard}>
                    <button
                      className={styles.arrowButton}
                      onClick={() => togglePeriod(index)}
                      aria-label="toggle-period"
                    >
                      {expandedPeriods[index] ? (
                        <UpOutlined />
                      ) : (
                        <DownOutlined />
                      )}
                    </button>
                  </div>
                </Col>
              )}
            </Row>
          </div>
          {expandedPeriods[index] && item.slabs && item.slabs.length > 0 && (
            <div className={styles.billBreakdownCard}>
              <div className={styles.breakdownHeader}>
                <div>
                  <h3 className={styles.breakdownTitle}>
                    {t('label_billBreakDown')}
                  </h3>
                </div>
              </div>
              <div className={styles.tableWrapper}>
                <CommonTable
                  className={styles.consumptionTable}
                  columns={consumptionsWithSlabs}
                  dataSource={item.slabs}
                  rowKey={(record, index) => index}
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ConsumptionCard;
